import { fetcher } from 'utils/axios';

export type CreateUpdatesFromNotePayload = {
  sessionId?: string | null;
  contactUserId?: string | null;
  taggerName?: string | null;
  /** שם איש הקשר — נכנס לנוסח ההתראה ("X תייג אותך בשיחה עם Y") */
  contactName?: string | null;
  noteText?: string | null;
  /** מזהי Udid (GUID) של המשתמשים שתויגו בהערה */
  mentionedUserIds: string[];
};

/**
 * יוצר עדכון (notification feed) לכל משתמש שתויג בהערה — מול שרת ה-node.
 * שקט בכשל: לא חוסם את שליחת ההערה עצמה (שנשארת מול שרת ה-C#).
 */
export async function createUpdatesFromNote(payload: CreateUpdatesFromNotePayload): Promise<boolean> {
  try {
    await fetcher('post', ['/api/updates/from-note', { data: payload }], 'servernode');
    return true;
  } catch (error) {
    console.error('[updates] createUpdatesFromNote failed', error);
    return false;
  }
}

export type UpdateFeedItem = {
  id: number | string;
  companyId: string;
  sessionId: string | null;
  messageId: number | null;
  contactUserId: string | null;
  targetUserId: string | null;
  status: 'unread' | 'read' | string | null;
  type: string | null;
  body: string | null;
  /** נתיב ניווט בתוך האפליקציה — הופך את שורת הפעמון ללחיצה */
  link?: string | null;
  createdAt: string;
};

export type FetchUpdatesResult = {
  items: UpdateFeedItem[];
  total: number;
  unreadCount: number;
};

/** שולף את ה-feed של המשתמש המחובר (השרת גוזר את הזהות מהאימות). */
export async function fetchUpdates(params?: { page?: number; pageSize?: number; status?: 'unread' | 'read' }): Promise<FetchUpdatesResult | null> {
  try {
    //* ב-fetcher, עבור GET השדה data ממופה ל-query params (ראה utils/axios.ts).
    const res = (await fetcher(
      'get',
      ['/api/updates', { data: { page: params?.page ?? 1, pageSize: params?.pageSize ?? 50, status: params?.status } }],
      'servernode',
    )) as { success: boolean; data: UpdateFeedItem[]; pagination?: { total?: number }; unreadCount?: number } | null;
    if (!res?.success || !Array.isArray(res.data)) return null;
    return { items: res.data, total: res.pagination?.total ?? res.data.length, unreadCount: res.unreadCount ?? 0 };
  } catch (error) {
    console.error('[updates] fetchUpdates failed', error);
    return null;
  }
}

/** מסמן עדכון בודד כנקרא (בלחיצה על שורת פעמון לחיצה). שקט בכשל — ה-UI כבר עודכן אופטימית. */
export async function markUpdateRead(updateId: number | string): Promise<boolean> {
  try {
    await fetcher('patch', [`/api/updates/${updateId}/status`, { data: { status: 'read' } }], 'servernode');
    return true;
  } catch (error) {
    console.error('[updates] markUpdateRead failed', error);
    return false;
  }
}

/** מסמן את כל העדכונים של המשתמש כנקראו. שקט בכשל — ה-UI כבר עודכן אופטימית. */
export async function markAllUpdatesRead(): Promise<boolean> {
  try {
    await fetcher('patch', ['/api/updates/read-all', { data: {} }], 'servernode');
    return true;
  } catch (error) {
    console.error('[updates] markAllUpdatesRead failed', error);
    return false;
  }
}
